import { ElementsArray } from 'polotno/model/group-model';
import { StoreType } from 'polotno/model/store';

export const canBringElementsToFront = (store: StoreType, elements: ElementsArray) => {
    return store.activePage?.canMoveElementsTop(elements.map(element => element.id));
};

export const canBringElementsForward = (store: StoreType, elements: ElementsArray) => {
    return store.activePage?.canMoveElementsUp(elements.map(element => element.id));
};

export const canSendElementsToBack = (store: StoreType, elements: ElementsArray) => {
    return store.activePage?.canMoveElementsBottom(elements.map(element => element.id));
};

export const canSendElementsBackward = (store: StoreType, elements: ElementsArray) => {
    return store.activePage?.canMoveElementsDown(elements.map(element => element.id));
};
